import styled from 'styled-components';

export const MobView = styled.div`
  &.main-text {
    padding: 23px 0 5px 0;
  }
  &.main-text .heeeeeart{
    position: absolute;
    top: 23px;
    left: -29px;
  }
  &.main-text .qqqrcode {
    position: absolute;
    top: 23px;
    right: -94px;
  }
  &.main-text span {
    position: relative;
    color: #fff;
    font-family: 'Organetto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 180.8%;
    text-align: center;
    letter-spacing: 0.21em;
    padding: 20px 0 10px 0;
  }
`;